<template>
  <b-card class="rounded-xl">
    <div class="h-full">
      <div>
        <div>
          <h2 class="text-2xl font-semibold">
            Integration
          </h2>

          <small class=" text-muted "
            >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
          </small>
        </div>

        <div class=" lg:grid md:grid grid-cols-4  gap-8 mt-12">
          <b-card
            v-for="(item, index) in cards"
            :key="'item-' + index"
            class="p-4 cust-shadow "
            no-body
          >
            <div class="flex justify-center mt-2">
              <img :src="item.img" class=" object-cover w-1/2 rounded-t-lg" />
            </div>
            <div
              class="text-center cursor-pointer  mt-4"
              @click="handleClick(item)"
            >
              <h3 class="font-bold hover:underline  text-md">
                {{ item.text }}
              </h3>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <div></div>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";

export default {
  data() {
    return {
      cards: [
        {
          img: require("./img/google.png"),
          text: "Google Analytics",
          route: "template-sms"
        },
        {
          img: require("./img/razor.png"),
          text: "Razorpay",
          route: "template-email"
        }
      ]
    };
  },
  methods: {
    handleClick({ route }) {
      this.$router.push({ name: route });
    }
  }
};
</script>
<style>
.vs-card--content {
  margin-bottom: 0px !important;
}
</style>
